import React, {
useState,
} from "react";

import api from "../../../api/api";

import {
TextField,
InputAdornment,
Button,
CircularProgress,
MenuItem,
FormControl,
InputLabel,
Select,
} from "@mui/material";

import {
Inventory2,
Numbers,
AttachMoney,
Image,
LocalShipping,
} from "@mui/icons-material";

import {
motion,
} from "framer-motion";

import Swal from "sweetalert2";

// ============================================================
// PRODUCT PAGE
// ============================================================

const Product = () => {

// ==========================================================
// FORM STATE
// ==========================================================

const [name, setName] =
useState("");

const [quantity, setQuantity] =
useState("");

const [price, setPrice] =
useState("");

const [wholesalePrice, setWholesalePrice] =
useState("");

const [unitType, setUnitType] =
useState("single");

const [unitsPerCarton, setUnitsPerCarton] =
useState(1);

const [image, setImage] =
useState(null);

const [loading, setLoading] =
useState(false);

const [productCreated, setProductCreated] =
useState(false);

const [createdProduct, setCreatedProduct] =
useState(null);

// ==========================================================
// RESET FORM
// ==========================================================

const resetForm = () => {


setName("");

setQuantity("");

setPrice("");

setWholesalePrice("");

setUnitType("single");

setUnitsPerCarton(1);

setImage(null);


const imageInput =
  document.getElementById(
    "image"
  );


if (imageInput) {

  imageInput.value = "";

}


};

// ==========================================================
// UNIT TYPE CHANGE
// ==========================================================

const handleUnitTypeChange = (
event
) => {


const value =
  event.target.value;


setUnitType(
  value
);


if (
  value === "single"
) {

  setUnitsPerCarton(
    1
  );

}


};

// ==========================================================
// CREATE PRODUCT
// ==========================================================

const handleSubmit = async (
e
) => {


e.preventDefault();


// ========================================================
// VALIDATE PRODUCT NAME
// ========================================================

if (
  !name.trim()
) {

  await Swal.fire({
    icon:
      "warning",

    title:
      "Product Name Required",

    text:
      "Please enter the product name.",

    confirmButtonText:
      "OK",

    confirmButtonColor:
      "#f97316",
  });

  return;

}


// ========================================================
// VALIDATE QUANTITY
// ========================================================

if (
  quantity === "" ||
  Number(quantity) <= 0
) {

  await Swal.fire({
    icon:
      "warning",

    title:
      "Invalid Quantity",

    text:
      unitType === "carton"
        ? "Enter the number of cartons you are adding to stock."
        : "Enter the number of individual units you are adding to stock.",

    confirmButtonText:
      "OK",

    confirmButtonColor:
      "#f97316",
  });

  return;

}


// ========================================================
// VALIDATE SELLING PRICE
// ========================================================

if (
  price === "" ||
  Number(price) < 0
) {

  await Swal.fire({
    icon:
      "warning",

    title:
      "Invalid Selling Price",

    text:
      "Please enter a valid selling price.",

    confirmButtonText:
      "OK",

    confirmButtonColor:
      "#f97316",
  });

  return;

}


// ========================================================
// VALIDATE PURCHASE PRICE
// ========================================================

if (
  wholesalePrice === "" ||
  Number(wholesalePrice) < 0
) {

  await Swal.fire({
    icon:
      "warning",

    title:
      "Invalid Purchase Price",

    text:
      "Please enter a valid purchase price.",

    confirmButtonText:
      "OK",

    confirmButtonColor:
      "#f97316",
  });

  return;

}


// ========================================================
// VALIDATE CARTON SIZE
// ========================================================

if (
  unitType === "carton" &&
  (
    unitsPerCarton === "" ||
    Number(unitsPerCarton) <= 0
  )
) {

  await Swal.fire({
    icon:
      "warning",

    title:
      "Invalid Carton Size",

    text:
      "Enter the number of individual pieces inside one carton.",

    confirmButtonText:
      "OK",

    confirmButtonColor:
      "#f97316",
  });

  return;

}


setLoading(
  true
);


try {


  const formData =
    new FormData();


  formData.append(
    "name",
    name.trim()
  );


  formData.append(
    "quantity",
    Number(quantity)
  );


  formData.append(
    "price",
    Number(price)
  );


  formData.append(
    "wholesale_price",
    Number(wholesalePrice)
  );


  formData.append(
    "unit_type",
    unitType
  );


  formData.append(
    "units_per_carton",
    unitType === "carton"
      ? Number(unitsPerCarton)
      : 1
  );


  if (image) {

    formData.append(
      "image",
      image
    );

  }


  const token =
    localStorage.getItem(
      "access"
    );


  const response =
    await api.post(
      "/api/products/",
      formData,
      {
        headers: {
          Authorization:
            `Bearer ${token}`,

          "Content-Type":
            "multipart/form-data",
        },
      }
    );


  setCreatedProduct(
    response.data
  );


  resetForm();


  setProductCreated(
    true
  );


  await Swal.fire({
    icon:
      "success",

    title:
      "Product Created!",

    text:
      "The product has been successfully added to your inventory.",

    confirmButtonText:
      "OK",

    confirmButtonColor:
      "#f97316",
  });


}

catch (error) {


  console.error(
    "Product creation error:",
    error
  );


  let errorMessage =
    "Failed to create product.";


  const backendError =
    error?.response?.data;


  if (
    backendError?.error
  ) {

    errorMessage =
      backendError.error;

  }

  else if (
    typeof backendError ===
    "string"
  ) {

    errorMessage =
      backendError;

  }

  else if (
    backendError &&
    typeof backendError ===
    "object"
  ) {


    const messages = [];


    Object.entries(
      backendError
    ).forEach(
      ([field, value]) => {


        if (
          Array.isArray(
            value
          )
        ) {

          messages.push(
            `${field}: ${value.join(", ")}`
          );

        }

        else {

          messages.push(
            `${field}: ${value}`
          );

        }


      }
    );


    if (
      messages.length > 0
    ) {

      errorMessage =
        messages.join(
          "\n"
        );

    }


  }


  await Swal.fire({
    icon:
      "error",

    title:
      "Unable to Create Product",

    text:
      errorMessage,

    confirmButtonText:
      "OK",

    confirmButtonColor:
      "#dc2626",
  });


}

finally {


  setLoading(
    false
  );


}


};

// ==========================================================
// CREATE ANOTHER PRODUCT
// ==========================================================

const handleCreateAnother = () => {


setProductCreated(
  false
);


setCreatedProduct(
  null
);


resetForm();


};

// ==========================================================
// PRODUCT CALCULATIONS
// ==========================================================

const totalPieces =
unitType === "carton"
? Number(quantity || 0) *
Number(unitsPerCarton || 0)
: Number(quantity || 0);

const sellingValue =
totalPieces *
Number(price || 0);

const purchaseCost =
unitType === "carton"
? Number(quantity || 0) *
Number(wholesalePrice || 0)
: Number(quantity || 0) *
Number(wholesalePrice || 0);

const profitPerUnit =
unitType === "carton"
? Number(price || 0) -
(
Number(wholesalePrice || 0) /
Number(unitsPerCarton || 1)
)
: Number(price || 0) -
Number(wholesalePrice || 0);

const totalProfit =
sellingValue -
purchaseCost;

// ==========================================================
// PAGE
// ==========================================================

return (


<>


  <style>

    {`

      * {
        box-sizing: border-box;
      }


      .product-page-wrapper {
        width: 100%;
        min-height: 100vh;
      }


      .product-main-container {
        width: 100%;
      }


      /* ==================================================
         IMPORTANT MUI MENU FIX
      ================================================== */

      .MuiPopover-root {
        z-index: 15000 !important;
      }


      .MuiMenu-root {
        z-index: 15000 !important;
      }


      .MuiModal-root {
        z-index: 15000 !important;
      }


      /* ==================================================
         TABLET
      ================================================== */

      @media (max-width: 900px) {

        .product-page-wrapper {

          padding:
            20px !important;

        }


        .product-main-container {

          grid-template-columns:
            1fr !important;

          min-height:
            auto !important;

          overflow:
            visible !important;

        }


        .product-brand-panel {

          order:
            1 !important;

          min-height:
            330px !important;

          padding:
            40px !important;

          justify-content:
            center !important;

          border-radius:
            24px 24px 0 0 !important;

        }


        .product-form-panel {

          order:
            2 !important;

          padding:
            30px !important;

          overflow:
            visible !important;

          border-radius:
            0 0 24px 24px !important;

        }

      }


      /* ==================================================
         MOBILE
      ================================================== */

      @media (max-width: 600px) {

        .product-page-wrapper {

          min-height:
            100dvh !important;

          padding:
            10px !important;

          align-items:
            flex-start !important;

        }


        .product-main-container {

          width:
            100% !important;

          max-width:
            100% !important;

          display:
            flex !important;

          flex-direction:
            column !important;

          border-radius:
            16px !important;

          overflow:
            visible !important;

          min-height:
            auto !important;

        }


        .product-brand-panel {

          order:
            1 !important;

          width:
            100% !important;

          min-height:
            auto !important;

          padding:
            28px 22px !important;

          display:
            block !important;

          border-radius:
            16px 16px 0 0 !important;

        }


        .product-brand-content {

          width:
            100% !important;

        }


        .product-brand-icon {

          width:
            52px !important;

          height:
            52px !important;

          border-radius:
            14px !important;

          margin-bottom:
            18px !important;

        }


        .product-brand-icon svg {

          font-size:
            28px !important;

        }


        .product-brand-title {

          font-size:
            30px !important;

          line-height:
            1.05 !important;

        }


        .product-brand-description {

          margin-top:
            14px !important;

          margin-bottom:
            22px !important;

          max-width:
            none !important;

          font-size:
            14px !important;

          line-height:
            1.55 !important;

        }


        .product-brand-features {

          gap:
            10px !important;

        }


        .product-brand-feature {

          font-size:
            13px !important;

          gap:
            9px !important;

        }


        .product-form-panel {

          order:
            2 !important;

          width:
            100% !important;

          padding:
            20px 12px !important;

          overflow:
            visible !important;

          border-radius:
            0 0 16px 16px !important;

        }


        .product-form-heading {

          margin-bottom:
            18px !important;

        }


        .product-form-heading h2 {

          font-size:
            24px !important;

        }


        .product-form-heading p {

          font-size:
            13px !important;

          line-height:
            1.5 !important;

        }


        .product-form-card {

          width:
            100% !important;

          padding:
            14px !important;

          border-radius:
            14px !important;

        }


        .product-form-card .MuiFormControl-root,
        .product-form-card .MuiTextField-root {

          width:
            100% !important;

          max-width:
            100% !important;

        }


        .product-form-card .MuiInputBase-root {

          min-height:
            52px !important;

        }


        .product-form-card .MuiInputBase-input {

          font-size:
            14px !important;

        }


        .product-form-card .MuiInputLabel-root {

          font-size:
            14px !important;

        }


        .product-form-card .MuiFormHelperText-root {

          font-size:
            11px !important;

          line-height:
            1.35 !important;

          margin-left:
            0 !important;

          margin-right:
            0 !important;

        }


        .inventory-preview {

          padding:
            14px !important;

          border-radius:
            12px !important;

        }


        .inventory-preview-grid {

          grid-template-columns:
            1fr 1fr !important;

          gap:
            14px 10px !important;

        }


        .product-image-upload {

          padding:
            14px !important;

        }


        .create-product-button {

          width:
            100% !important;

          min-height:
            52px !important;

          margin-top:
            18px !important;

          font-size:
            14px !important;

        }


        .product-success-wrapper {

          width:
            100% !important;

          min-height:
            auto !important;

          padding:
            10px 0 !important;

        }


        .product-success-card {

          width:
            100% !important;

          padding:
            28px 18px !important;

          border-radius:
            16px !important;

        }

      }


      /* ==================================================
         SMALL PHONES
      ================================================== */

      @media (max-width: 380px) {

        .product-page-wrapper {

          padding:
            6px !important;

        }


        .product-brand-panel {

          padding:
            24px 16px !important;

        }


        .product-form-panel {

          padding:
            16px 8px !important;

        }


        .product-form-card {

          padding:
            12px !important;

        }


        .inventory-preview-grid {

          grid-template-columns:
            1fr !important;

        }

      }

    `}

  </style>


  <div
    className="product-page-wrapper"
    style={{
      display:
        "flex",

      background:
        "linear-gradient(135deg, #111827 0%, #1f2937 45%, #f97316 150%)",

      fontFamily:
        "'Inter', 'Segoe UI', sans-serif",

      padding:
        "30px",

      overflowX:
        "hidden",
    }}
  >


    <div
      className="product-main-container"
      style={{
        maxWidth:
          "1180px",

        margin:
          "auto",

        display:
          "grid",

        gridTemplateColumns:
          "0.85fr 1.5fr",

        minHeight:
          "700px",

        borderRadius:
          "24px",

        background:
          "#ffffff",

        boxShadow:
          "0 25px 70px rgba(0,0,0,0.28)",

        overflow:
          "visible",

        position:
          "relative",

        isolation:
          "isolate",
      }}
    >


      {/* ==================================================
         LEFT BRAND PANEL
      ================================================== */}

      <div
        className="product-brand-panel"
        style={{
          position:
            "relative",

          display:
            "flex",

          flexDirection:
            "column",

          justifyContent:
            "center",

          padding:
            "55px",

          background:
            "linear-gradient(145deg, #111827, #1f2937)",

          color:
            "#ffffff",

          borderTopLeftRadius:
            "24px",

          borderBottomLeftRadius:
            "24px",

          overflow:
            "hidden",
        }}
      >


        <div
          style={{
            position:
              "absolute",

            width:
              "280px",

            height:
              "280px",

            borderRadius:
              "50%",

            background:
              "rgba(249,115,22,0.12)",

            top:
              "-100px",

            right:
              "-100px",

            pointerEvents:
              "none",
          }}
        />


        <motion.div
          className="product-brand-content"
          initial={{
            opacity: 0,
            x: -30,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 0.5,
          }}
          style={{
            position:
              "relative",

            zIndex:
              1,
          }}
        >


          <div
            className="product-brand-icon"
            style={{
              width:
                "64px",

              height:
                "64px",

              borderRadius:
                "18px",

              display:
                "flex",

              alignItems:
                "center",

              justifyContent:
                "center",

              background:
                "rgba(249,115,22,0.16)",

              border:
                "1px solid rgba(249,115,22,0.3)",

              marginBottom:
                "28px",
            }}
          >

            <Inventory2
              style={{
                fontSize:
                  34,

                color:
                  "#f97316",
              }}
            />

          </div>


          <h1
            className="product-brand-title"
            style={{
              margin:
                0,

              fontSize:
                "38px",

              lineHeight:
                1.1,

              fontWeight:
                800,

              letterSpacing:
                "-1px",
            }}
          >

            Zuluwhiskey

            <br />

            Store

          </h1>


          <p
            className="product-brand-description"
            style={{
              marginTop:
                "18px",

              marginBottom:
                "35px",

              color:
                "#d1d5db",

              fontSize:
                "16px",

              lineHeight:
                1.7,

              maxWidth:
                "340px",
            }}
          >

            Manage your inventory professionally,
            keep accurate stock records, and track
            your product values and profits.

          </p>


          <div
            className="product-brand-features"
            style={{
              display:
                "flex",

              flexDirection:
                "column",

              gap:
                "15px",
            }}
          >

            {[
              "Track products and stock",
              "Manage individual and carton products",
              "Monitor selling value and profit",
            ].map(
              (item, index) => (

                <div
                  className="product-brand-feature"
                  key={index}
                  style={{
                    display:
                      "flex",

                    alignItems:
                      "center",

                    gap:
                      "12px",

                    color:
                      "#e5e7eb",

                    fontSize:
                      "14px",
                  }}
                >

                  <div
                    style={{
                      width:
                        "8px",

                      height:
                        "8px",

                      borderRadius:
                        "50%",

                      background:
                        "#f97316",

                      flexShrink:
                        0,
                    }}
                  />

                  {item}

                </div>

              )
            )}

          </div>


        </motion.div>


      </div>


      {/* ==================================================
         RIGHT FORM PANEL
      ================================================== */}

      <div
        className="product-form-panel"
        style={{
          background:
            "#f8fafc",

          padding:
            "42px",

          overflow:
            "visible",

          borderTopRightRadius:
            "24px",

          borderBottomRightRadius:
            "24px",

          position:
            "relative",
        }}
      >


        {!productCreated ? (


          <motion.div
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{
              duration: 0.3,
            }}
            style={{
              width:
                "100%",

              overflow:
                "visible",
            }}
          >


            <div
              className="product-form-heading"
              style={{
                marginBottom:
                  "24px",
              }}
            >


              <h2
                style={{
                  margin:
                    0,

                  fontSize:
                    "28px",

                  fontWeight:
                    800,

                  color:
                    "#111827",
                }}
              >

                Add Product

              </h2>


              <p
                style={{
                  margin:
                    "7px 0 0",

                  color:
                    "#6b7280",

                  fontSize:
                    "14px",
                }}
              >

                Create a new product and add it
                to your inventory.

              </p>


            </div>


            <form
              onSubmit={handleSubmit}
              style={{
                width:
                  "100%",
              }}
            >


              <div
                className="product-form-card"
                style={{
                  background:
                    "#ffffff",

                  border:
                    "1px solid #e5e7eb",

                  borderRadius:
                    "16px",

                  padding:
                    "22px",

                  boxShadow:
                    "0 5px 18px rgba(0,0,0,0.04)",

                  overflow:
                    "visible",
                }}
              >


                {/* PRODUCT NAME */}

                <TextField
                  fullWidth
                  label="Product Name"
                  value={name}
                  onChange={(e) =>
                    setName(
                      e.target.value
                    )
                  }
                  required
                  margin="normal"
                  InputProps={{
                    startAdornment: (

                      <InputAdornment
                        position="start"
                      >

                        <Inventory2
                          style={{
                            color:
                              "#f97316",
                          }}
                        />

                      </InputAdornment>

                    ),
                  }}
                />


                {/* ==================================================
                   UNIT TYPE
                   FIXED DROPDOWN
                ================================================== */}

                <FormControl
                  fullWidth
                  margin="normal"
                  variant="outlined"
                >


                  <InputLabel
                    id="unit-type-label"
                  >

                    Unit Type

                  </InputLabel>


                  <Select
                    labelId="unit-type-label"
                    id="unit-type"
                    value={unitType}
                    label="Unit Type"
                    onChange={
                      handleUnitTypeChange
                    }
                    MenuProps={{
                      disablePortal:
                        false,

                      disableScrollLock:
                        true,

                      transitionDuration:
                        0,

                      anchorOrigin: {
                        vertical:
                          "bottom",

                        horizontal:
                          "left",
                      },

                      transformOrigin: {
                        vertical:
                          "top",

                        horizontal:
                          "left",
                      },

                      PaperProps: {
                        sx: {
                          maxHeight:
                            240,

                          mt:
                            0.5,

                          borderRadius:
                            2,

                          minWidth:
                            200,

                          boxShadow:
                            "0 12px 30px rgba(0,0,0,0.18)",

                          overflowY:
                            "auto",

                          zIndex:
                            15000,
                        },
                      },
                    }}
                    sx={{
                      width:
                        "100%",

                      backgroundColor:
                        "#ffffff",

                      "& .MuiSelect-select": {
                        minHeight:
                          "24px",

                        display:
                          "flex",

                        alignItems:
                          "center",
                      },
                    }}
                  >


                    <MenuItem
                      value="single"
                    >

                      Single Unit

                    </MenuItem>


                    <MenuItem
                      value="carton"
                    >

                      Carton

                    </MenuItem>


                  </Select>


                </FormControl>


                {/* ==================================================
                   UNITS PER CARTON
                ================================================== */}

                {unitType === "carton" && (


                  <TextField
                    fullWidth
                    label="Units Per Carton"
                    type="number"
                    value={
                      unitsPerCarton
                    }
                    onChange={(e) =>
                      setUnitsPerCarton(
                        e.target.value
                      )
                    }
                    required
                    margin="normal"
                    helperText={
                      "Number of pieces inside ONE carton."
                    }
                    inputProps={{
                      min:
                        1,
                    }}
                    InputProps={{
                      startAdornment: (

                        <InputAdornment
                          position="start"
                        >

                          <LocalShipping
                            style={{
                              color:
                                "#f97316",
                            }}
                          />

                        </InputAdornment>

                      ),
                    }}
                  />


                )}


                {/* QUANTITY */}

                <TextField
                  fullWidth
                  label={
                    unitType === "carton"
                      ? "Quantity (Cartons)"
                      : "Quantity (Units)"
                  }
                  type="number"
                  value={quantity}
                  onChange={(e) =>
                    setQuantity(
                      e.target.value
                    )
                  }
                  required
                  margin="normal"
                  helperText={
                    unitType === "carton"
                      ? "Number of cartons being added to stock."
                      : "Number of individual units being added to stock."
                  }
                  inputProps={{
                    min:
                      1,
                  }}
                  InputProps={{
                    startAdornment: (

                      <InputAdornment
                        position="start"
                      >

                        <Numbers
                          style={{
                            color:
                              "#f97316",
                          }}
                        />

                      </InputAdornment>

                    ),
                  }}
                />


                {/* SELLING PRICE */}

                <TextField
                  fullWidth
                  label="Selling Price (Per Unit)"
                  type="number"
                  value={price}
                  onChange={(e) =>
                    setPrice(
                      e.target.value
                    )
                  }
                  required
                  margin="normal"
                  helperText={
                    "Price you will sell ONE individual piece for."
                  }
                  inputProps={{
                    min:
                      0,

                    step:
                      "0.01",
                  }}
                  InputProps={{
                    startAdornment: (

                      <InputAdornment
                        position="start"
                      >

                        <AttachMoney
                          style={{
                            color:
                              "#f97316",
                          }}
                        />

                      </InputAdornment>

                    ),
                  }}
                />


                {/* PURCHASE COST */}

                <TextField
                  fullWidth
                  label={
                    unitType === "carton"
                      ? "Purchase Cost (Per Carton)"
                      : "Purchase Cost (Per Unit)"
                  }
                  type="number"
                  value={
                    wholesalePrice
                  }
                  onChange={(e) =>
                    setWholesalePrice(
                      e.target.value
                    )
                  }
                  required
                  margin="normal"
                  helperText={
                    unitType === "carton"
                      ? "What you paid for ONE complete carton."
                      : "What you paid for ONE unit."
                  }
                  inputProps={{
                    min:
                      0,

                    step:
                      "0.01",
                  }}
                  InputProps={{
                    startAdornment: (

                      <InputAdornment
                        position="start"
                      >

                        <AttachMoney
                          style={{
                            color:
                              "#f97316",
                          }}
                        />

                      </InputAdornment>

                    ),
                  }}
                />


                {/* ==================================================
                   INVENTORY PREVIEW
                ================================================== */}

                {(quantity !== "" ||
                  price !== "" ||
                  wholesalePrice !== "") && (


                  <div
                    className="inventory-preview"
                    style={{
                      marginTop:
                        "20px",

                      padding:
                        "18px",

                      borderRadius:
                        "14px",

                      background:
                        "#fff7ed",

                      border:
                        "1px solid #fed7aa",
                    }}
                  >


                    <div
                      style={{
                        fontSize:
                          "13px",

                        fontWeight:
                          700,

                        color:
                          "#9a3412",

                        marginBottom:
                          "12px",
                      }}
                    >

                      Inventory Preview

                    </div>


                    <div
                      className="inventory-preview-grid"
                      style={{
                        display:
                          "grid",

                        gridTemplateColumns:
                          "repeat(2, 1fr)",

                        gap:
                          "10px",
                      }}
                    >


                      <div>

                        <span
                          style={{
                            display:
                              "block",

                            fontSize:
                              "11px",

                            color:
                              "#78716c",
                          }}
                        >

                          Total Pieces

                        </span>

                        <strong
                          style={{
                            fontSize:
                              "15px",

                            color:
                              "#111827",
                          }}
                        >

                          {totalPieces.toLocaleString()}

                        </strong>

                      </div>


                      <div>

                        <span
                          style={{
                            display:
                              "block",

                            fontSize:
                              "11px",

                            color:
                              "#78716c",
                          }}
                        >

                          Total Selling Value

                        </span>

                        <strong
                          style={{
                            fontSize:
                              "15px",

                            color:
                              "#111827",
                          }}
                        >

                          L${" "}

                          {sellingValue.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits:
                                2,

                              maximumFractionDigits:
                                2,
                            }
                          )}

                        </strong>

                      </div>


                      <div>

                        <span
                          style={{
                            display:
                              "block",

                            fontSize:
                              "11px",

                            color:
                              "#78716c",
                          }}
                        >

                          Profit Per Unit

                        </span>

                        <strong
                          style={{
                            fontSize:
                              "15px",

                            color:
                              profitPerUnit >= 0
                                ? "#15803d"
                                : "#dc2626",
                          }}
                        >

                          L${" "}

                          {profitPerUnit.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits:
                                2,

                              maximumFractionDigits:
                                2,
                            }
                          )}

                        </strong>

                      </div>


                      <div>

                        <span
                          style={{
                            display:
                              "block",

                            fontSize:
                              "11px",

                            color:
                              "#78716c",
                          }}
                        >

                          Total Profit

                        </span>

                        <strong
                          style={{
                            fontSize:
                              "15px",

                            color:
                              totalProfit >= 0
                                ? "#15803d"
                                : "#dc2626",
                          }}
                        >

                          L${" "}

                          {totalProfit.toLocaleString(
                            undefined,
                            {
                              minimumFractionDigits:
                                2,

                              maximumFractionDigits:
                                2,
                            }
                          )}

                        </strong>

                      </div>


                    </div>


                  </div>


                )}


                {/* ==================================================
                   IMAGE UPLOAD
                ================================================== */}

                <div
                  className="product-image-upload"
                  style={{
                    marginTop:
                      "20px",

                    padding:
                      "18px",

                    border:
                      "1px dashed #cbd5e1",

                    borderRadius:
                      "14px",

                    background:
                      "#f8fafc",
                  }}
                >


                  <label
                    htmlFor="image"
                    style={{
                      display:
                        "flex",

                      alignItems:
                        "center",

                      gap:
                        "10px",

                      cursor:
                        "pointer",

                      color:
                        "#374151",

                      fontWeight:
                        600,

                      fontSize:
                        "14px",
                    }}
                  >

                    <Image
                      style={{
                        color:
                          "#f97316",
                      }}
                    />

                    Upload Product Image

                  </label>


                  <input
                    type="file"
                    id="image"
                    accept="image/*"
                    onChange={(e) =>
                      setImage(
                        e.target.files?.[0] ||
                        null
                      )
                    }
                    style={{
                      width:
                        "100%",

                      marginTop:
                        "12px",

                      fontSize:
                        "13px",
                    }}
                  />


                  {image && (


                    <div
                      style={{
                        marginTop:
                          "8px",

                        fontSize:
                          "12px",

                        color:
                          "#6b7280",

                        wordBreak:
                          "break-word",
                      }}
                    >

                      Selected:{" "}

                      {image.name}

                    </div>


                  )}


                </div>


                {/* ==================================================
                   SUBMIT BUTTON
                ================================================== */}

                <Button
                  className="create-product-button"
                  fullWidth
                  type="submit"
                  disabled={loading}
                  variant="contained"
                  sx={{
                    marginTop:
                      2.5,

                    minHeight:
                      52,

                    borderRadius:
                      "12px",

                    textTransform:
                      "none",

                    fontSize:
                      "15px",

                    fontWeight:
                      700,

                    background:
                      "#f97316",

                    boxShadow:
                      "0 8px 20px rgba(249,115,22,0.25)",

                    "&:hover": {
                      background:
                        "#ea580c",

                      boxShadow:
                        "0 10px 25px rgba(249,115,22,0.3)",
                    },
                  }}
                >


                  {loading ? (


                    <CircularProgress
                      size={22}
                      sx={{
                        color:
                          "#ffffff",
                      }}
                    />


                  ) : (

                    "Create Product"

                  )}


                </Button>


              </div>


            </form>


          </motion.div>


        ) : (


          <motion.div
            className="product-success-wrapper"
            initial={{
              opacity:
                0,

              scale:
                0.96,
            }}
            animate={{
              opacity:
                1,

              scale:
                1,
            }}
            transition={{
              duration:
                0.4,
            }}
            style={{
              minHeight:
                "100%",

              display:
                "flex",

              alignItems:
                "center",

              justifyContent:
                "center",
            }}
          >


            <div
              className="product-success-card"
              style={{
                width:
                  "100%",

                maxWidth:
                  "520px",

                textAlign:
                  "center",

                background:
                  "#ffffff",

                border:
                  "1px solid #e5e7eb",

                borderRadius:
                  "22px",

                padding:
                  "45px 35px",

                boxShadow:
                  "0 15px 45px rgba(0,0,0,0.08)",
              }}
            >


              <div
                style={{
                  width:
                    "80px",

                  height:
                    "80px",

                  borderRadius:
                    "50%",

                  margin:
                    "0 auto 22px",

                  display:
                    "flex",

                  alignItems:
                    "center",

                  justifyContent:
                    "center",

                  background:
                    "#dcfce7",

                  color:
                    "#16a34a",

                  fontSize:
                    "38px",

                  fontWeight:
                    800,
                }}
              >

                ✓

              </div>


              <h2
                style={{
                  margin:
                    0,

                  fontSize:
                    "27px",

                  fontWeight:
                    800,

                  color:
                    "#111827",
                }}
              >

                Product Created Successfully

              </h2>


              <p
                style={{
                  margin:
                    "10px 0 28px",

                  color:
                    "#6b7280",

                  fontSize:
                    "14px",

                  lineHeight:
                    1.6,
                }}
              >

                The product has been successfully
                added to your inventory.

              </p>


              {createdProduct && (


                <div
                  style={{
                    textAlign:
                      "left",

                    background:
                      "#f8fafc",

                    border:
                      "1px solid #e5e7eb",

                    borderRadius:
                      "14px",

                    padding:
                      "18px",

                    marginBottom:
                      "25px",
                  }}
                >


                  <div
                    style={{
                      display:
                        "flex",

                      justifyContent:
                        "space-between",

                      gap:
                        "15px",

                      marginBottom:
                        "10px",
                    }}
                  >

                    <span>
                      Product
                    </span>

                    <strong>
                      {createdProduct.name}
                    </strong>

                  </div>


                  <div
                    style={{
                      display:
                        "flex",

                      justifyContent:
                        "space-between",

                      gap:
                        "15px",

                      marginBottom:
                        "10px",
                    }}
                  >

                    <span>
                      Type
                    </span>

                    <strong>

                      {createdProduct.unit_type ===
                      "carton"
                        ? "Carton"
                        : "Single Unit"}

                    </strong>

                  </div>


                  <div
                    style={{
                      display:
                        "flex",

                      justifyContent:
                        "space-between",

                      gap:
                        "15px",
                    }}
                  >

                    <span>
                      Selling Price
                    </span>

                    <strong
                      style={{
                        color:
                          "#15803d",
                      }}
                    >

                      L${" "}

                      {Number(
                        createdProduct.price ||
                        0
                      ).toLocaleString(
                        undefined,
                        {
                          minimumFractionDigits:
                            2,

                          maximumFractionDigits:
                            2,
                        }
                      )}

                    </strong>

                  </div>


                </div>


              )}


              <Button
                fullWidth
                variant="contained"
                onClick={
                  handleCreateAnother
                }
                sx={{
                  minHeight:
                    50,

                  borderRadius:
                    "12px",

                  textTransform:
                    "none",

                  fontSize:
                    "15px",

                  fontWeight:
                    700,

                  background:
                    "#f97316",

                  "&:hover": {
                    background:
                      "#ea580c",
                  },
                }}
              >

                Create Another Product

              </Button>


            </div>


          </motion.div>


        )}


      </div>


    </div>


  </div>


</>


);

};

export default Product;
